// extracted by mini-css-extract-plugin
module.exports = {"container":"da51a739f7--container--p4rlj","image":"da51a739f7--image--VwWoa","content":"da51a739f7--content--OlNLD","title":"da51a739f7--title--ddjRK"};